import Logger from '../../logging/logger';

const onResize = ( ctx, event ) => {
    Logger.info( '[map] Map Resizing', {
        originalEvent: event,
    } );

    const rect = window.document.documentElement.getBoundingClientRect();

    if ( rect.height !== window.innerHeight ) {
        document.documentElement.style.height = `${window.innerHeight}px`;
    }

    requestAnimationFrame( () => {
        ctx.map.resize();
    } );
};

export default onResize;
